import React, { useEffect } from "react";
import { RootState } from "store/store";
import { connect } from "react-redux";
import { Modal } from "antd";
import i18n from "i18n";
import { Form, Input } from "antd";
import { splitStringByNewline, emailIsInvalid } from "../../utils/strings";
import {
  SurveyProductSettings,
  SurveyProductSettingsUpdateItem,
} from "api/sms-api";
import { updateSurveyProductSettings } from "./ProductSettingsActions";

const { TextArea } = Input;

interface ProductsSettingMailProps {
  existingParams: any;
  selectedProducts: Array<SurveyProductSettings>;
  visible: boolean;
  closeModal: () => void;
  emails: Array<string | null>;

  updateSurveyProductSettings: (
    form: Array<SurveyProductSettingsUpdateItem>,
    existingParams: any
  ) => void;
}

const ProductsSettingMail: React.FC<ProductsSettingMailProps> = (props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      recipientEmail: props.emails.join("\n") || "",
    });
  }, [props.emails]);

  const onClickSetEmailButton = (value: { recipientEmail: string }) => {
    const mailArray = splitStringByNewline(value.recipientEmail);
    const updateItems = props.selectedProducts.map((item) => {
      return {
        id: item.id,
        recipientEmail: mailArray,
      };
    });
    props.updateSurveyProductSettings(updateItems, props.existingParams);
    form.resetFields();
    props.closeModal();
  };

  const onClickCancelButton = () => {
    form.resetFields();
    props.closeModal();
  };

  return (
    <Modal
      visible={props.visible}
      title={i18n.t("productSettings.table.settings.recipientEmail")}
      okText={i18n.t("common.save")}
      cancelText={i18n.t("common.cancel")}
      onCancel={onClickCancelButton}
      onOk={() => {
        form.validateFields().then((values) => {
          onClickSetEmailButton(values);
        });
      }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="recipientEmail"
          className="input-mail-form"
          validateTrigger={["onBlur"]}
          rules={[
            {
              validator(_, value) {
                const mailArray = splitStringByNewline(value);
                if (!emailIsInvalid(mailArray)) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(i18n.t("validation.mail")));
              },
            },
          ]}
        >
          <TextArea
            placeholder={i18n.t(
              "productSettings.settingMail.inputMailPlaceholder"
            )}
            autoSize={{ minRows: 5 }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    selectedProducts: state.productSettings.selectedProducts,
  };
};

const mapDispatchToProps = {
  updateSurveyProductSettings,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductsSettingMail);
